<template>
  <section name="server">
    <section class="down">
      <header class="header left"><h1>{{ $t('issue') }}</h1></header>
      <heim-dashboard-list>
        <transition-group name="slide-fade" class="list-ctn" tag="section">
          <span v-for="(server, idx) in items" :key="'server-' + idx">
            <heim-server-card class="issue" :server="server" v-if="isServerDown(server)"></heim-server-card>
          </span>
        </transition-group>
      </heim-dashboard-list>
    </section>
    <section class="up">
      <header class="header left"><h1>{{ $t('noIssue') }}</h1></header>
      <heim-dashboard-list>
        <transition-group name="slide-fade" class="list-ctn" tag="section">
          <span v-for="(server, idx) in items" :key="'server-' + idx">
            <heim-server-card :class="server.errCount > 0?'warn':''" :server="server" v-if="!isServerDown(server)"></heim-server-card>
          </span>
        </transition-group>
      </heim-dashboard-list>
    </section>
  </section>
</template>

<script>
// @ is an alias to /src
import HeimDashboardList from "@/components/layout/list/heim-dashboard-list";
import HeimServerCard from "@/components/layout/card/heim-server-card";
import { mapState } from "vuex";
import fuseMixin from "@/mixins/fuse";
export default {
  name: "serverDashboard",
  components: {
    HeimDashboardList,
    HeimServerCard
  },
  mixins: [fuseMixin],
  mounted() {
    this.$store.dispatch("getServers");
    // we need to setup fuse inside a watcher
    // because otherwise fuse setups itselfs
    // with an empty array (no data has arrived yet)
    this.$watch(vm => vm.servers, val => this.setupServers());
    this.setupServers();

    this.$store.dispatch("setTitle", "Dashboard - Servers");
  },
  computed: {
    ...mapState(["search"]),
    ...mapState({ servers: state => state.serversState.servers }),
    ...mapState({ serverHealth: state => state.serversState.serverHealth }),
    items() {
      const servers = this.filteredServers.filter(
        server => server.enabled == true
      );
      for (let idx = 0; idx < servers.length; idx++) {
        const server = servers[idx];
        const logs = this.$store.getters.getServerHealth(`server-${server.id}`);
        server.logs = [];
        if (typeof logs != "undefined")
          server.logs = logs.slice(
            Math.max(logs.length - (server.nb_occurence + 1), 1)
          );
      }
      return servers;
    }
  },
  methods: {
    isServerDown(server) {
      server.errCount = 0;
      if (server.logs.length <= 0) return false;
      for (let idx = 0; idx < server.logs.length; idx++) {
        const element = server.logs[idx];
        if (
          (server.cpu_alert && server.cpu_threshold <= element.cpu_usage) ||
          (server.mem_alert && server.mem_threshold <= element.mem_usage) ||
          (server.drive_alert && server.drive_threshold <= element.drive_usage)
        )
          server.errCount++;
        else server.errCount = 0;
      }
      return server.errCount >= server.nb_occurence ? true : false;
    }
  }
};
</script>

<style scoped>
</style>
